import React, { useState } from 'react';
import './navbar.css';
import { useNavigate } from 'react-router-dom';

const Navbar = () => {
    const [showProfile, setShowProfile] = useState(false);
    const navigate = useNavigate();
    const toggleProfile = () => {

        localStorage.removeItem('userData');
        localStorage.removeItem('username');
        navigate('/login');
        // setShowProfile(!showProfile)
    }

    const handleLogout = () => {
        setShowProfile(false);
        localStorage.removeItem('userData');
        localStorage.removeItem('username');
        navigate('/login');
    }

    const handleProfileClick = () => {
        setShowProfile(false);
        navigate('/profile');
    }

    return (
        <nav className="dashboard-navbar">
            <div className="navbar-logo">
                <img src="/helth.png" alt="HealthLabs AI" className="navbar1-logo-img" />
            </div>
            <div className="navbar-actions">
                {/* <button className="navbar-icon-btn" title="Notifications">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M18 8A6 6 0 1 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" stroke="#718096" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M13.73 21a2 2 0 0 1-3.46 0" stroke="#718096" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>
                <button className="navbar-icon-btn" title="Settings">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="3" stroke="#718096" strokeWidth="2" />
                        <path d="M12 1v3m0 16v3M4.22 4.22l2.12 2.12m11.32 11.32l2.12 2.12M1 12h3m16 0h3M4.22 19.78l2.12-2.12m11.32-11.32l2.12-2.12"
                            stroke="#718096" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                </button> */}
                <button className="navbar-icon-btn logout-btn" title="Logout" onClick={toggleProfile}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path
                            className="logout-icon-path"
                            d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <polyline
                            className="logout-icon-path"
                            points="16 17 21 12 16 7"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <line
                            className="logout-icon-path"
                            x1="21"
                            y1="12"
                            x2="9"
                            y2="12"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </button>

                {showProfile && (
                    <div className="profile-dropdown">
                        {/* <div className="profile-item" onClick={handleProfileClick}>Profile</div> */}
                        <div className="profile-divider"></div>
                        <div className="profile-item logout" onClick={handleLogout}>Logout</div>
                    </div>
                )}

            </div>
        </nav>
    )
}
export default Navbar;